/** Minimal duck type that matches both QueryDocumentSnapshot and DocumentSnapshot
 *  regardless of how Firestore typed its internal generics. Avoids fighting
 *  the SDK's `<unknown, DocumentData>` vs `<DocumentData, DocumentData>` variance. */
interface DocLike {
  id: string;
  data: () => unknown;
}

/** Map a Firestore doc snapshot to a typed `{ id, ...data }` object. */
export function fromDoc<T>(d: DocLike): T {
  return { id: d.id, ...(d.data() as object) } as T;
}
